import React from 'react';
import DropDown from './DropDown.react';
import Icon from 'components/Icon/Icon.react';
import types from './Constants';
import styles from 'components/BoxFieldset/BoxFieldset.scss';

const BoxFieldset = ({ el, color, children, zIndex }) => {
  const title = types[el].title;
  const desc = types[el].desc;

  const customStyle = zIndex ? { zIndex, position: 'relative' } : {};

  return (
    <div className={styles.fieldset} style={customStyle}>
      {
        title &&
          <div
            className={[styles.legend, color && styles[color]].join(' ')}
            dangerouslySetInnerHTML={{
              __html: title,
            }} />
      }
      {
        desc &&
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: desc,
            }} />
      }
      {
        Object.keys(types[el]).length > 2 &&
          <div className={styles.helpSection}>
            <DropDown items={types[el]} />
          </div>
      }
      {
        children &&
          <div className={styles.fields}>
            { children }
          </div>
      }
    </div>
  );
}

export default BoxFieldset;
